export const OWN_DATA_TABS = {
  personalInfo: 'personalInfo',
  workingConditions: 'workingConditions',
  paymentAndInsurance: 'paymentAndInsurance',
  employeeDocuments: 'employeeDocuments',
};
